import _ from 'lodash';

export const cleanQuery = query => _.replace(_.kebabCase(_.deburr(query)), /-/g, '');

// Position de la saisie dans le nom, sinon dans le meilleur alias (null si aucune correspondance)
const findMatch = (partner, name, cleanedQuery) => {
    const nameIndex = cleanQuery(name).indexOf(cleanedQuery);
    if (nameIndex !== -1) {
        return { byAlias: false, index: nameIndex };
    }

    const aliasIndexes = (partner.nameMatchings || [])
        .map(alias => cleanQuery(alias).indexOf(cleanedQuery))
        .filter(index => index !== -1);

    return aliasIndexes.length > 0 ? { byAlias: true, index: Math.min(...aliasIndexes) } : null;
};

// Nom réel avant alias, puis position de la saisie, puis ordre alphabétique
const compareMatches = (a, b) => {
    if (a.match.byAlias !== b.match.byAlias) {
        return a.match.byAlias ? 1 : -1;
    }

    if (a.match.index !== b.match.index) {
        return a.match.index - b.match.index;
    }

    return a.name.localeCompare(b.name, 'fr', { sensitivity: 'base' });
};

// getName : nom affiché du marchand, s'il diffère de partner.name (carte entreprise)
export const searchPartners = (partners, query, getName = partner => partner.name) => {
    const cleanedQuery = cleanQuery(query);

    return partners
        .map(partner => {
            const name = getName(partner);
            return { partner, name, match: findMatch(partner, name, cleanedQuery) };
        })
        .filter(({ match }) => match !== null)
        .sort(compareMatches)
        .map(({ partner }) => partner);
};



// WEBPACK FOOTER //
// ./src/services/search/utils.js